import type { SxProps, Theme } from '@mui/material/styles';

export function orgLogoImageSx(): SxProps<Theme> {
  return {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
    display: 'block',
  };
}

export function appBarLogoTraySx(theme: Pick<Theme, 'palette'>): SxProps<Theme> {
  const dark = theme.palette.mode === 'dark';
  return {
    bgcolor: dark ? 'rgba(255, 255, 255, 0.97)' : 'background.paper',
    boxShadow: dark ? '0 2px 10px rgba(0, 0, 0, 0.28)' : '0 2px 8px rgba(0, 0, 0, 0.12)',
  };
}

export function appBarLogoImageSx(): SxProps<Theme> {
  return orgLogoImageSx();
}

export function sideMenuLogoTraySx(): SxProps<Theme> {
  return {
    bgcolor: 'rgba(255, 255, 255, 0.97)',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.25)',
  };
}

export function sideMenuLogoImageSx(): SxProps<Theme> {
  return orgLogoImageSx();
}

export function loginLogoTraySx(isDarkUi: boolean): SxProps<Theme> {
  return {
    backgroundColor: isDarkUi ? 'rgba(255, 255, 255, 0.97)' : 'background.paper',
    boxShadow: isDarkUi
      ? '0 2px 14px rgba(0, 0, 0, 0.35)'
      : '0 2px 12px rgba(0, 0, 0, 0.12)',
  };
}

export function loginLogoImageSx(): SxProps<Theme> {
  return orgLogoImageSx();
}
